import { render, staticRenderFns } from "./DobPicker.vue?vue&type=template&id=c032d8c4&scoped=true&"
import script from "./DobPicker.vue?vue&type=script&lang=ts&"
export * from "./DobPicker.vue?vue&type=script&lang=ts&"
import style0 from "./DobPicker.vue?vue&type=style&index=0&id=c032d8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c032d8c4",
  null
  
)

export default component.exports